import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient, HttpClientJsonpModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SwiperModule } from 'ngx-swiper-wrapper';
import {DragDropModule} from '@angular/cdk/drag-drop';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { PartnersComponent } from './components/partners/partners.component';

import { MatTabsModule } from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatStepperModule} from '@angular/material/stepper';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { BackingComponent } from './components/backing/backing.component';
import { ContentTabsComponent } from './components/content-tabs/content-tabs.component';

import { AnimateModule } from './components/animate/animate.module';

import { OwlModule } from 'ngx-owl-carousel';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { TeamComponent } from './components/team/team.component';
import { ConnectComponent } from './components/connect/connect.component';

import {MatMenuModule} from '@angular/material/menu';

import { NgxParallaxScrollModule } from 'ngx-parallax-scroll';
//import { NgxParallaxScrollModule } from '@boatzako/ngx-parallax-scroll';
import { CountUpModule } from 'ngx-countup';
import { VisaClientComponent } from './components/visa-client/visa-client.component';
import { CryptmiComponent } from './components/cryptmi/cryptmi.component';
import { CymiComponent } from './components/cymi/cymi.component';

import {ScrollingModule} from '@angular/cdk/scrolling';
import { SolutionsDosComponent } from './components/solutions-dos/solutions-dos.component';
import { SolutionsComponent } from './components/solutions/solutions.component';
import { AnimateWithScrollDirective } from './components/solutions/animate-with-scroll.directive.directive';
import { CymiV2Component } from './components/cymi-v2/cymi-v2.component';
import { AnimationLogoComponent } from './components/animation-logo/animation-logo.component';
import { CymiWorldComponent } from './components/cymi-world/cymi-world.component';
import { NoticePressComponent } from './components/partners/notice-press/notice-press.component';
import { NoticePress2Component } from './components/partners/notice-press2/notice-press2.component';
import { NoticePress3Component } from './components/partners/notice-press3/notice-press3.component';
import { NoticePress4Component } from './components/partners/notice-press4/notice-press4.component';
import { MenaRegionComponent } from './components/mena-region/mena-region.component';
import { MenaCarouselComponent } from './components/mena-carousel/mena-carousel.component';
import { NoticePress5Component } from './components/partners/notice-press5/notice-press5.component';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NoticePress6Component } from './components/partners/notice-press6/notice-press6.component';
import { NoticePress7Component } from './components/partners/notice-press7/notice-press7.component';
import { DeleteAccountComponent } from './components/delete-account/delete-account.component';
import { RegisterComponent } from './components/register/register.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NoticePress8Component } from './components/partners/notice-press8/notice-press8.component';
import { Backing2Component } from './components/backing2/backing2.component';
import { OneComponent } from './components/one/one.component';
import { RegisterReserveComponent } from './components/register-reserve/register-reserve.component';
import { WoldAsOneComponent } from './components/wold-as-one/wold-as-one.component';
import { ImagineAppComponent } from './components/imagine-app/imagine-app.component';
import { NoticePress9Component } from './components/partners/notice-press9/notice-press9.component';
import { NoticePress10Component } from './components/partners/notice-press10/notice-press10.component';
import { NoticePress11Component } from './components/partners/notice-press11/notice-press11.component';
import { GmixComponent } from './components/gmix/gmix.component';
import { GmixWorldComponent } from './components/gmix-world/gmix-world.component';
import { NoticePress12Component } from './components/partners/notice-press12/notice-press12.component';
import { NoticePress13Component } from './components/partners/notice-press13/notice-press13.component';
import { NoticePress14Component } from './components/partners/notice-press14/notice-press14.component';
import { NoticePress15Component } from './components/partners/notice-press15/notice-press15.component';
import { NoticePress16Component } from './components/partners/notice-press16/notice-press16.component';
import { NoticePress17Component } from './components/partners/notice-press17/notice-press17.component';
import { NoticePress18Component } from './components/partners/notice-press18/notice-press18.component';
import { StartFormComponent } from './components/start-form/start-form.component';
import { SafeUrlPipe } from './pipe/dom-sanitizer.pipe';
import { FilterByCountryPipe } from './pipe/filter-by-country.pipe';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NoticePress25Component } from './components/partners/notice-press25/notice-press25.component';
import { NoticePress26Component } from './components/partners/notice-press26/notice-press26.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, ' ./assets/translate/i18n/', '.json');
}



@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    AppComponent,
    HomeComponent,
    PartnersComponent,
    TabsComponent,
    BackingComponent,
    ContentTabsComponent,
    TeamComponent,
    ConnectComponent,
    VisaClientComponent,
    CryptmiComponent,
    CymiComponent,
    SolutionsDosComponent,
    SolutionsComponent,
    AnimateWithScrollDirective,
    CymiV2Component,
    AnimationLogoComponent,
    CymiWorldComponent,
    NoticePressComponent,
    NoticePress2Component,
    NoticePress3Component,
    NoticePress4Component,
    MenaRegionComponent,
    MenaCarouselComponent,
    NoticePress5Component,
    NoticePress6Component,
    NoticePress7Component,
    DeleteAccountComponent,
    RegisterComponent,
    NoticePress8Component,
    Backing2Component,
    OneComponent,
    RegisterReserveComponent,
    WoldAsOneComponent,
    ImagineAppComponent,
    NoticePress9Component,
    NoticePress10Component,
    NoticePress11Component,
    GmixComponent,
    GmixWorldComponent,
    NoticePress12Component,
    NoticePress13Component,
    NoticePress14Component,
    NoticePress15Component,
    NoticePress16Component,
    NoticePress17Component,
    NoticePress18Component,
    StartFormComponent,
    FilterByCountryPipe,
    SafeUrlPipe,
    NoticePress25Component,
    NoticePress26Component
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatTabsModule,
    HttpClientModule,
    FlexLayoutModule,
    SwiperModule,
    AnimateModule,
    DragDropModule,
    OwlModule ,
    NgxPageScrollCoreModule,
    NgxPageScrollModule,
    MatExpansionModule,
    MatMenuModule,
    NgxParallaxScrollModule,
    CountUpModule,
    MatStepperModule,
    ScrollingModule,
    PdfViewerModule,
    FormsModule, 
    ReactiveFormsModule,
    HttpClientJsonpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    SweetAlert2Module.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
